<template>
  <div>
    <v-data-table
      :headers="tableHeaders"
      :items="wages"
      class="mb-2 ml-4"
      hide-actions
      item-key="id"
    >
      <template v-slot:items="props">
        <td>
          <div
            v-for="(label, index) in getLabelForPath(props.item.path)"
            :key="index"
          >
            {{ label }}
          </div>
        </td>
        <td>
          {{ getLableForMonthRange(props.item.validFrom, props.item.validTo) }}
        </td>
        <td>{{ props.item.mindeststundenlohn }}</td>
        <td>{{ props.item.mindeststundenlohnPlus13ML }}</td>
        <td>
          <div>
            <button
              v-if="canUserEdit"
              v-b-tooltip.hover
              class="btn btn-primary smallActionButton"
              placement="bottom"
              title="Mindestlohn bearbeiten"
              type="button"
              @click="editWage(props.item)"
            >
              <i class="fas fa-edit" />
            </button>
            <button
              v-if="canUserEdit"
              v-b-modal.deleteRule
              v-b-tooltip.hover
              class="btn btn-danger smallActionButton ml-1"
              placement="bottom"
              title="Mindestlohn löschen"
              type="button"
              @click="deleteWage(props.item)"
            >
              <i class="fas fa-trash-alt" />
            </button>
          </div>
        </td>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { GetDisplayValueOfPath } from "@/helpers/PlzHelper.js";
import { GetFullMonthList, GetMonthRangeLabel } from "@/helpers/DateHelper";

export default {
  props: {
    wages: {
      type: Array,
      required: false,
      default: () => [],
    },
  },
  data() {
    return {
      tableHeaders: [
        {
          text: "Gültigkeitsbereich",
          align: "left",
          sortable: true,
          value: "canton",
          width: "20%",
        },
        {
          text: "Gültigkeit",
          allign: "left",
          sortable: true,
          value: "year",
          width: "20%",
        },
        {
          text: "Mindest Basisstundenlohn wenn kein 13. Monatslohn",
          align: "left",
          sortable: false,
          value: "mindeststundenlohn",
          width: "20%",
        },
        {
          text: "Mindest Basisstundenlohn wenn 13. Monatslohn",
          align: "left",
          sortable: false,
          value: "mindeststundenlohnPlus13ML",
          width: "20%",
        },
        { text: "Actions", align: "left", sortable: false, width: "10%" },
      ],
    };
  },
  computed: {
    canUserEdit() {
      return (
        this.$IsUserInRole("VertragsmanagementVerwaltung") &&
        this.$IsUserInRole("GesetzlicheMindestloehneVerwaltung")
      );
    },
    monthList() {
      return GetFullMonthList();
    },
  },
  methods: {
    getLabelForPath(path) {
      let paths = path.split(";");
      let labels = [];
      paths.forEach((wagePath) => {
        labels.push(
          GetDisplayValueOfPath(
            wagePath,
            this.$store.state.mindestLohnKonfiguration.Cities,
          ),
        );
      });
      return labels;
    },
    getLableForMonthRange(validFrom, validTo) {
      return GetMonthRangeLabel(validFrom, validTo);
    },
    editWage(wage) {
      this.$emit("editWage", wage);
    },
    deleteWage(wage) {
      this.$emit("deleteWage", wage);
    },
  },
};
</script>

<style scoped></style>
